import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import AInput from '../../common/formFeilds/customInput/AInput';
import moment from 'moment';
import ADataGrid from '../../common/data-grid/EnhanceDataGrid';
import { GridRowModes } from '@mui/x-data-grid';
import { isObjEmpty } from '../../common/utils/methods/commonMethods/utilityMethod';
import { failureToast } from '../../common/utils/methods/toasterFunctions/function';
import { saveOrDeleteMsg } from '../../edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { generateRandomId } from '../../common/utils/methods/commonMethods/utilityMethod';
import { AGridColDef } from '../../common/data-grid/ADataGridColDef';
import AAutoComplete from '../../common/form-fields-mui/AAutoComplete';
import { useGetCourseIdsForBUAndTerm } from '../../edpOps/stockManagement/customhooks';
import AButton from '../../common/form-fields-mui/AButton';
import { ActionsCellComponent, StatusCellComponent } from '../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { editCellContainerStyle } from '../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { newRow } from './utils';
import ConcessionCategoryDialog from './ConcessionCategoryDialog';
const _ = require("lodash");


const ListComponent = ({
    dropdownData = {},
    isPANIndiaConfig,
    paginationInfo = {},
    rows,
    createUpdateHandler,
    loading,
    getConfigsData
}, ref) => {


    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    const [concessionCategoryDialogInfo, setConcessionCategoryDialogInfo] = useState({});


    const rowFormHandler = (value, key) =>
        setRowForm((prev) => ({ ...prev, [key]: value }));

    useEffect(() => {
        setRowData(rows);
    }, [rows]);


    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        debugger
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let randomId = generateRandomId();
            let emptyRow = {
                ...newRow(isPANIndiaConfig),
                isNew: true,
                id: randomId,
            };
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const [courseIdDropdown, courseIdDropdownLoading] =
        useGetCourseIdsForBUAndTerm({
            businessArea: rowForm?.businessArea,
            term: rowForm?.term,
        });

    const allMandatoryFieldsEntered = () => {
        console.log(Object.keys(newRow(isPANIndiaConfig)));
        return Object.keys(newRow(isPANIndiaConfig))?.every(field => Boolean(rowForm[field]));
    }

    const columns = [
        new AGridColDef('businessGroup', 'Business Group', false)
            .setMinWidth(130)
            .setFlex(0.9)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.businessGroup}
                        handleChange={value => {
                            rowFormHandler(value, 'businessGroup');
                        }}
                        items={dropdownData?.academicGroup}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        new AGridColDef('companyCode', 'Company Code', false)
            .setMinWidth(130)
            .setFlex(0.9)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.companyCode}
                        handleChange={value => {
                            rowFormHandler(value, 'companyCode');
                        }}
                        items={dropdownData?.companyCode}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        new AGridColDef('academicCareer', 'Academic Career', false)
            .setMinWidth(130)
            .setFlex(0.9)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.academicCareer}
                        handleChange={value => {
                            rowFormHandler(value, 'academicCareer');
                        }}
                        items={dropdownData?.academicCareer}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef('term', 'Term', false)
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(true)
            .setValueGetter(params => params?.value?.label)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.term}
                        handleChange={value => {
                            rowFormHandler(value, 'term');
                        }}
                        items={dropdownData?.term}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),

        ...(!isPANIndiaConfig ? [
            new AGridColDef('businessArea', 'Business Area', false)
                .setMinWidth(130)
                .setFlex(0.9)
                .editable(true)
                .setValueGetter(params => params?.value?.label)
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.businessArea}
                            handleChange={value => {
                                rowFormHandler(value, 'businessArea');
                            }}
                            items={dropdownData?.businessArea}
                            isMulti={false}
                            //   style={selectStyles}
                            placeholder={'Select'}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef('courseId', 'Course Id', false)
                .setMinWidth(110)
                .setFlex(0.9)
                .editable(true)
                .setValueGetter(params => params?.value)
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={
                                _.isObject(rowForm?.courseId) 
                                ?  rowForm?.courseId 
                                : courseIdDropdown?.find(cId => cId?.value == rowForm?.courseId)
                            }
                            handleChange={value => {
                                rowFormHandler(value, 'courseId');
                            }}
                            items={courseIdDropdown}
                            isMulti={false}
                            isLoading={courseIdDropdownLoading}
                            placeholder={'Select'}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                ))
        ] : []),
        new AGridColDef('ratio', 'Ratio', false)
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(true)
            .setValueGetter(params => params?.value)
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        value={rowForm?.ratio}
                        handler={val => rowFormHandler(val, 'ratio')}
                        placeholder={'Enter'}
                        maxLength={100}
                    />
                </div>
            )),
        new AGridColDef('category', 'Category', false)
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(true)
            .renderCellComponent(params => {
                return (
                    <AButton
                        variant='link'
                        size='xs'
                        className='no-ml-btn'
                        onClick={() => {
                            setConcessionCategoryDialogInfo({
                                isOpen: true,
                                viewOnly: true,
                            })

                            setRowForm({ ...params?.row })
                        }}
                    >
                        View
                    </AButton>
                )
            })
            .renderEditCellComponent(params => {
                return (
                    <AButton
                        variant='link'
                        size='xs'
                        className='no-ml-btn'
                        onClick={() => {
                            setConcessionCategoryDialogInfo({
                                isOpen: true,
                                viewOnly: false,
                            })
                        }}
                    >
                        {rowForm?.categoryId ? 'Edit' : 'Add'}
                    </AButton>
                )
            }),
        new AGridColDef('status', 'Status', false)
            .setMinWidth(90)
            .setFlex(0.4)
            .editable(true)
            .renderCellComponent(params =>
                <StatusCellComponent value={params.value} />
            )
            .renderEditCellComponent(params => (
                <StatusCellComponent
                    value={rowForm?.status}
                    handleChange={val => rowFormHandler(val, 'status')}
                />
            )),

        new AGridColDef('updatedOn', 'Updated On')
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(false)
            .renderCellComponent(params => (
                <div>{moment(params.value).format('DD-MMM-YYYY hh:mm a')}</div>
            )),

        new AGridColDef('updatedBy', 'Updated By')
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(false)
            .renderCellComponent(params => (
                <div>{params.value}</div>
            )),

        new AGridColDef('createdOn', 'Created On')
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(false)
            .renderCellComponent(params => (
                <div>{moment(params.value).format('DD-MMM-YYYY hh:mm a')}</div>
            )),

        new AGridColDef('createdBy', 'Created By')
            .setMinWidth(110)
            .setFlex(0.9)
            .editable(false)
            .renderCellComponent(params => (
                <div>{params.value}</div>
            )),

        new AGridColDef('actions', 'Action', false)
            .setMinWidth(110)
            .setFlex(0.6)
            .editable(true)
            // .pinColumnLast(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    params={params}
                    customEditIcon
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    params={params}
                    isSaveDisabled={!allMandatoryFieldsEntered()}
                />
            )),

    ]

    const { totalRecords, currPage, currPageSize } = paginationInfo;

    return (
        <>
            <ADataGrid
                rowModesModel={rowModesModel}
                removeWrapperContainer
                rows={rowData || []}
                columns={columns}
                rowId={(row) => row.id}
                // rowHeight={50}
                loading={loading}
                rowCount={totalRecords}
                height="600px"
                nextButtonHandler={(pageNo, pageSize) =>
                    getConfigsData({ pageNo, pageSize })
                }
                pinLastColumn
                paginationModel={{ page: currPage, pageSize: currPageSize }}
            />

            <ConcessionCategoryDialog
                categoryData={dropdownData?.categories}
                dialogInfo={concessionCategoryDialogInfo}
                setDialogInfo={setConcessionCategoryDialogInfo}
                rowForm={rowForm}
                setRowForm={setRowForm}
                key={!!concessionCategoryDialogInfo?.isOpen}

            />
        </>

    );
}

export default forwardRef(ListComponent);